/** Lenses flow UI — keep keys in sync across fi / en / sv */

export const lensComponentsFi = {
  startView: {
    title: 'Kuution kuusi linssiä',
    subtitle:
      'Tarkastellaan valittua vipupistettä kuuden linssin läpi. Jokainen linssi nostaa esiin erilaisia esteitä ja mahdollisuuksia — teknologiasta arvoihin, taloudesta politiikkaan.',
    labelPivot: 'vipupistettä',
    labelLens: 'linssiä',
    goalTitle: 'Löydetään esteet ja mahdollisuudet',
    goalSubtitle: 'Jokainen linssi nostaa esiin oman näkökulmansa',
    cta: 'Aloitetaan!',
  },
};

export const lensComponentsEn = {
  startView: {
    title: "The Cube's six lenses",
    subtitle:
      'We examine the chosen pivot point through six lenses. Each lens surfaces different barriers and opportunities — from technology to values, from economy to politics.',
    labelPivot: 'pivot points',
    labelLens: 'lenses',
    goalTitle: 'Find the barriers and opportunities',
    goalSubtitle: 'Each lens surfaces its own perspective',
    cta: "Let's go!",
  },
};

export const lensComponentsSv = {
  startView: {
    title: 'Kubens sex linser',
    subtitle:
      'Vi granskar den valda vridpunkten genom sex linser. Varje lins lyfter fram olika hinder och möjligheter — från teknik till värderingar, från ekonomi till politik.',
    labelPivot: 'vridpunkter',
    labelLens: 'linser',
    goalTitle: 'Hitta hinder och möjligheter',
    goalSubtitle: 'Varje lins lyfter fram sitt eget perspektiv',
    cta: 'Vi börjar!',
  },
};
